import React from 'react';
import { Button, Modal, RedDivider } from 'src/features/common';
import {
  ButtonParamType,
  DefaultButtonStyle,
} from 'src/features/common/components/button/revamp-button';

interface Props {
  visible: boolean;
  onVisible?: () => void;
  onClose: () => void;
  onConfirm?: () => void;
  onCancel: () => void;
  heading: string;
  subtext?: string;
  confirmButtonLabel?: string;
  cancelButtonLabel: string;
}

export function ConfirmModal(props: Props) {
  React.useEffect(() => {
    if (props.onVisible && props.visible) {
      props.onVisible();
    }
  });

  return (
    <Modal onClose={props.onClose} visible={props.visible} size="small">
      <section className="flex flex-col items-center gap-7">
        <h1 className="text-4xl font-medium">{props.heading}</h1>
        <h3 className="text-lg font-normal text-center">{props.subtext}</h3>
        <RedDivider />
        <section className="flex flex-col items-center w-4/5 gap-7">
          {props.onConfirm && (
            <Button
              buttonStyle={DefaultButtonStyle()
                .hasPrimaryAction()
                .isMediumSize()
                .hasLightMode()
                .build()}
              buttonParams={{
                type: ButtonParamType.NormalButton,
                onClick: props.onConfirm,
              }}
              className="w-56"
              automationid={`DA_Retry_Button`}
            >
              {props.confirmButtonLabel || ''}
            </Button>
          )}

          <Button
            buttonStyle={DefaultButtonStyle()
              .hasSecondaryAction()
              .isMediumSize()
              .hasLightMode()
              .build()}
            buttonParams={{
              type: ButtonParamType.NormalButton,
              onClick: props.onCancel,
            }}
            className="w-56 !text-black"
            automationid={`DA_Enter_manually_Button`}
          >
            {props.cancelButtonLabel}
          </Button>
        </section>
      </section>
    </Modal>
  );
}
